import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({ selector: '[ktHoverClass]' })
export class HoverClassDirective {
  @Input('ktHoverClass') hoverClass: string;

  constructor(private elementRef: ElementRef) {}

  @HostListener('mouseenter')
  handleMouseEnter() {
    if (this.hoverClass) this.elementRef.nativeElement.classList.add(this.hoverClass);
  }

  @HostListener('mouseleave')
  handleMouseLeave() {
    if (this.hoverClass) this.elementRef.nativeElement.classList.remove(this.hoverClass);
  }
}
